import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Typography, Grid } from "@mui/material";

import { TextField } from "../../../components";
import { useAxios, useComponent } from "../../../hooks";
import { colors } from "../../css components/Style";
import {
  Accept,
  CancelButton,
  Pending,
  Reject,
} from "../../css components/Button";

const MainHeading = styled(Typography)`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 42px;
`;

const SubHeading = styled(Typography)`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #000000;
`;

export default function FormDisplay({
  handleClose,
  formikProps,
  takeUp,
  setTakeUp,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { alert } = useComponent();

  const [loading, setLoading] = useState(false);

  function handleAddText(text) {
    setTakeUp((prev) => ({
      ...prev,
      data: setNote(prev.data),
    }));

    function setNote(val) {
      val.dp_note = val.dp_note + text;
      return val;
    }
  }

  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        style={{
          borderColor:
            takeUp.action === "REJECTED"
              ? colors.error
              : takeUp.action === "PENDING"
              ? colors.yellow
              : colors.green,
          borderBottom: "1px solid #333",
        }}
      />
      <Grid item xs={12}>
        <MainHeading
          color={
            takeUp.action === "REJECTED"
              ? colors.error
              : takeUp.action === "PENDING"
              ? colors.yellow
              : colors.green
          }
        >{`We would like to take action on the offer.`}</MainHeading>
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          borderColor:
            takeUp.action === "REJECTED"
              ? colors.error
              : takeUp.action === "PENDING"
              ? colors.warning
              : colors.success,
          borderBottom: "1px solid #333",
        }}
      />
      <Grid item xs={12}>
        <SubHeading>You can send a custom message to the Brand</SubHeading>
      </Grid>

      <Grid item xs={12}>
        <TextField
          value={takeUp?.data?.dp_note}
          rows={5}
          multiline
          name="dp_note"
          onChange={handleChange}
        />
      </Grid>

      <Grid item>
        <CancelButton
          style={{}}
          onClick={() => handleAddText(" Contact Us in")}
          variant="outlined"
        >
          Contact Us in
        </CancelButton>
      </Grid>

      <Grid item>
        <CancelButton
          onClick={() => handleAddText(" Tell us more")}
          variant="outlined"
        >
          Tell us more
        </CancelButton>
      </Grid>

      <Grid item>
        <CancelButton
          onClick={() => handleAddText(" Let's Talk")}
          variant="outlined"
        >
          Let's Talk
        </CancelButton>
      </Grid>

      <Grid item xs={12} />

      <Grid item xs />

      <Grid item>
        <CancelButton variant="outlined" onClick={handleClose}>
          Cancel
        </CancelButton>
      </Grid>

      <Grid item>
        {takeUp.action === "REJECTED" ? (
          <Reject
            type="submit"
            variant="contained"
            onClick={handleTakeUpOffer}
            loading={loading}
          >
            Reject
          </Reject>
        ) : takeUp.action === "PENDING" ? (
          <Pending
            type="submit"
            variant="contained"
            onClick={handleTakeUpOffer}
            loading={loading}
          >
            Pending
          </Pending>
        ) : (
          <Accept
            type="submit"
            variant="contained"
            onClick={handleTakeUpOffer}
            loading={loading}
          >
            Accept
          </Accept>
        )}
      </Grid>
    </React.Fragment>
  );

  function handleChange(e) {
    setTakeUp((prev) => ({
      ...prev,
      data: setNote(prev.data),
    }));

    function setNote(val) {
      val.dp_note = e.target.value;
      return val;
    }
  }

  function handleTakeUpOffer() {
    setLoading(true);
    axios({
      url: "/user/campaignOfferDP",
      method: "POST",
      data: { ...takeUp.data, requestStatus: takeUp.action },
      disableRedirect: true,
    }).then((res) => {
      handleClose();
      if (res.status) {
        setLoading(false);
        formikProps.setValues((prev) => ({
          ...prev,
          campaignStatus: takeUp.action,
        }));
        dispatch(alert.success(res.message.displayMessage));
      }
    });
  }
}
